import { BreadcrumbGroup, BreadcrumbGroupProps } from '@amzn/awsui-components-core';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { navigatePreservingParams } from 'src/utils/navigationUtils';

interface BreadcrumbsProps {
  items: BreadcrumbGroupProps.Item[];
}
export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  const navigate = useNavigate();

  const onFollowEvent = useCallback(
    (event: CustomEvent<BreadcrumbGroupProps.ClickDetail<BreadcrumbGroupProps.Item>>) => {
      if (!event.detail.external) {
        event.preventDefault();
        navigatePreservingParams(navigate, event.detail.href);
      }
    },
    [navigate]
  );

  return <BreadcrumbGroup expandAriaLabel="Show path" ariaLabel="Breadcrumbs" items={items} onFollow={onFollowEvent} />;
};
